// @flow
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import qs from 'qs';
import cx from 'classnames';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/styles';
import {
    Button,
    Input,
    InputAdornment,
    Toolbar,
} from '@material-ui/core';
import {
    Add as AddIcon,
    Search as SearchIcon,
} from '@material-ui/icons';
import type { Connector } from 'react-redux';
import type { TFunction } from 'react-i18next';
import type { ContextRouter } from 'react-router';
import { USER_ROLES } from '../../../../../browser/shared/constant/UserRoles';
import { selectors } from './duck';
import styles from './styles';
import type { State as RootState } from '../../../../redux/initialState';

type OwnProps = ContextRouter & {
    className?: string,
    classes: Object,
    t: TFunction,
};

type StateProps = {
    oldProjectBuilder: boolean,
    search: {
        size?: number,
        page?: number,
        q?: string,
        sort?: string,
        order?: string,
    },
    user: ?Object,
};
type DispatchProps = {};
type Props = OwnProps & StateProps & DispatchProps;

export class SearchToolbar extends Component<Props> {
    handleQueryChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
        const { value } = event.target;
        const { location, history, search } = this.props;
        const { q, ...query } = search;

        history.replace({
            pathname: location.pathname,
            search: qs.stringify(
                value ? { ...query, q: value } : query,
                { addQueryPrefix: true, encodeValuesOnly: true }
            ),
        });
    };

    render() {
        const { className, classes, oldProjectBuilder, match, search, t, user } = this.props;
        const orgId = parseInt(match.params.orgId, 10);
        const userRole = user ? user.role : '';

        return (
            <Toolbar className={cx(classes.root, className)} disableGutters>
                <Input
                  className={cx(classes.input, classes.outlined)}
                  disableUnderline
                  fullWidth
                  onChange={this.handleQueryChange}
                  placeholder={t('subscriptionList.searchPlaceholder')}
                  value={search.q || ''}
                  startAdornment={(
                      <InputAdornment position="start">
                          <SearchIcon />
                      </InputAdornment>
                  )}
                />
                {![USER_ROLES.PLATFORM_ADMIN, USER_ROLES.OPERATOR].includes(userRole)
                    ? (
                        <Button
                          className={classes.addButton}
                          variant="contained"
                          color="secondary"
                          component={Link}
                          to={oldProjectBuilder ? `/projects/${orgId}/draft/new` : `/projects/${orgId}/create/new`}
                        >
                            <AddIcon className={classes.addIcon} />
                            {t('subscriptionList.newProject')}
                        </Button>
                    )
                    : null
                }
            </Toolbar>
        );
    }
}

const mapStateToProps = (state: RootState, props: OwnProps): StateProps => ({
    ...selectors.getAPIParams(state, props),
    oldProjectBuilder: state.session.features.oldProjectBuilder,
    search: selectors.parseSearchParams(state, props),
    user: state.session.user,
});

const connector: Connector<OwnProps, Props> = connect(mapStateToProps);
const enhance = compose(
    withStyles(styles, { name: 'SearchToolbar' }),
    withTranslation(),
    connector
);

export default enhance(SearchToolbar);
